// topBar.js (simplified snippet)
import React, { useContext, Fragment } from "react";
import { UserProfile } from "../components/profile";
import { Bars3Icon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { GlobalSearch } from "../components/search";
import { Menu, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export default function TopBar({ setSidebarOpen }) {
  const { authContext, logout } = useContext(AuthContext);

  const handleLogout = () => {
    // Handle click event
    logout();
  };

  return (
    <div className="z-40 flex h-16 items-center lg:py-8 px-6 lg:pr-9">
      <button
        type="button"
        className="m-2.5 p-2.5 text-gray-700 dark:text-gray-200 lg:hidden"
        onClick={() => setSidebarOpen(true)}
      >
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="relative flex flex-1 items-center">
          <GlobalSearch />
        </div>

        <div className="flex items-center gap-x-4 lg:gap-x-2">
          <Menu as="div" className="relative">
            <Menu.Button className="flex items-center text-gray-400 hover:text-gray-700 dark:hover:text-gray-100 duration-200 transition-colors group">
              <span className="sr-only">Open user menu</span>
              <div className="flex items-center">
                <UserProfile
                  imageUrl={authContext.user.imageUrl}
                  size="small"
                  firstName={authContext.user.firstName}
                  lastName={authContext.user.lastName}
                  useInitials={!authContext.user.imageUrl}
                  className="group-hover:bg-gray-50 group-hover:text-gray-800"
                  spacing="mr-1.5"
                />
                <span className="hidden lg:flex lg:items-center">
                  <ChevronDownIcon
                    className="h-3 w-3 ml-0.5"
                    aria-hidden="true"
                  />
                </span>
              </div>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-20 mt-2.5 w-32 origin-top-right rounded-md bg-white dark:bg-gray-800 p-1 shadow-lg ring-1 ring-black/5 dark:ring-gray-700 focus:outline-none">
                <Menu.Item>
                  <Link
                    to="/profile/"
                    className="block w-full text-left px-2 py-1 text-sm leading-6 text-black dark:text-gray-100 cursor-pointer rounded-sm bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 duration-150 transition-colors"
                  >
                    Profile
                  </Link>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-2 py-1 text-sm leading-6 text-black dark:text-gray-100 cursor-pointer rounded-sm bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 duration-150 transition-colors"
                  >
                    Logout
                  </button>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </div>
  );
}
